module.exports = __webpack_public_path__ + "static/media/mps1_v5.9db30769.jpg";